module.exports = __webpack_public_path__ + "4e99cb8a463bcacc8f9129313678a2a2.svg";